import store from "@/store"

import {
    mapState
} from "vuex"

import zh from "../../public/lang/zh.js" //中文
import ko from "../../public/lang/ko.js" //韩语

import {getUserInfoApi, getUserGameInfo, getGameUrlMainApi, getGameUrlApi} from "@/api"

export default {
    data() {
        const allLang = {
            zh,
            ko
        }
        return {
            allLang
        }
    },
    computed: {
        ...mapState(['lang'])
    },
    methods: {
        l(agent) { //语言
            return this.allLang[this.lang][agent]
        },
        limg() {
            return this.lang === 'zh' ? '' : `_${this.lang}`
        },
        useInterceptedOnMounted(callback) {
            this.$nextTick(() => {
                let recursionDesired = async () => {
                    let _next = window?.configGlobal
                    if (_next) {
                        callback()
                    } else {
                        setTimeout(() => {
                            recursionDesired()
                        }, 100)
                    }
                }
                recursionDesired()
            })
        },
        setStoreState(payload) {
            store.commit('setStateVal', payload)
        },
        rounding(event) { //输入框取整
            const value = event.target.value

            this.$nextTick(() => {
                this.formData.money = parseInt(value)
            })
        },
        //验证是否登录
        isLogin(modal) {
            let _bool = JSON.stringify(store.state.userInfo) !== '{}' ? true : false
            if (modal && !_bool) {
                this.$message({type: 'warning', message: '请先登录'})
                this.setStoreState({prop: 'showLogin', value: 'login'})
            }
            return _bool
        },
        async rotateAnimate(agent, beforeCallBack) { //agent => dom 的ref
            let _oldName = ''
            if (agent) {
                if (this.$refs[agent].classList.value.indexOf('rotateSpin') >= 0) return
                _oldName = this.$refs[agent].className
                this.$refs[agent].className += ' rotateSpin'
            }

            let _beforeCallBackRes = await beforeCallBack()

            if (_beforeCallBackRes.message === 'success') {
                await this.updateInfo()
            }

            setTimeout(() => {
                if (agent && this.$refs[agent]) {
                    this.$refs[agent].className = _oldName
                }
            }, 1000)
        },
        //更新获取个人信息
        async updateInfo() {
            let _res = null
            if (store.state.token) {	//验证TOken 登录状态才更新信息
                await getUserInfoApi({
                    venueId: sessionStorage.getItem('venueId') || 0
                }).then(res => {
                    if (!res.data) return
                    // res.data.balance = 20000
                    // res.data.hasPinCode = false
                    localStorage.setItem('userInfo', JSON.stringify(res.data))
                    this.setStoreState({
                        prop: 'userInfo',
                        value: res.data
                    })
                    _res = res.data
                })
                //更新我的游戏盈亏 注单
                await getUserGameInfo().then(res => {
                    if (!res.data) return
                    localStorage.setItem('bagInfo', JSON.stringify(res.data))
                    this.setStoreState({
                        prop: 'bagInfo',
                        value: res.data
                    })
                })
            }
            return _res
        },
        checkUrlSpeed(url) {    //筛选最快链接
            return new Promise((resolve, reject) => {
                let startTime = Date.now();
                fetch(url, {
                    method: 'GET',
                })
                    .then(response => {
                        if (!response.ok) {
                            throw new Error(`Failed to fetch: ${url} - Status code: ${response.status}`);
                        }
                        return response.json(); // Assuming the response is JSON
                    })
                    .then(data => {
                        if (data?.code === 0) { // Assuming 'code' is part of the response data
                            let endTime = Date.now();
                            let duration = endTime - startTime;
                            resolve({
                                url: url,
                                time: duration
                            });
                        } else {
                            reject(new Error('Response code is not 0: ' + url));
                        }
                    })
                    .catch(error => {
                        reject(new Error('Fetch error: ' + url + ' - ' + error.message));
                    });
            });
        },
        navToGame(item) { //导航到游戏
            //如果路径相同 则返回
            if (this.$route.path === item.url) return;

            //回到首页
            if (item.url === '/') {
                this.$router.push({path: item.url})
                return
            }

            if (!item.name) return

            if (!this.isLogin(true)) return //检测是否登录

            let _currentClick = store.state.navBarInfo.filter(l => l.name === item.name)

            //未找到对应数据则返回
            if (_currentClick.length === 0) {
                this.$message({type: 'warning', message: '暂未开放'})
                return
            }
            const _lobby = _currentClick[0]['lobby']
            //lobby是不是 0 ，如果是0 ,就直接进入游戏
            //如果lobby是1 就 进入游戏列表

            let _fn = () => {
                //缓存当前的venueId
                sessionStorage.setItem('venueId', _currentClick[0].venueId)

                this.$router.push({path: _lobby === 0 ? `/webView/${item.name}` : `/gameList/${item.name}`}).catch(err => {
                })
            }

            if (_lobby === 0) {
                this.loginGame(_currentClick[0], _fn)
                return
            }

            if (_lobby === 1) {
                //缓存当前点击的数据
                localStorage.setItem('gameList', JSON.stringify(_currentClick[0]))
                _fn()
                return
            }
        },
        //登录游戏
        async loginGame(item, callBack) {
            // console.log(item);
            if (!this.isLogin(true)) return

            //status === 0
            if (item.status === 0) {
                this.$message({type: 'warning', message: '维护中'})
                return
            }
            //缓存当前游戏配置信息

            //如果PlatId为1  则调用 “获取官方游戏登录链接”接口
            let _res = null
            // if (item.platId === 1) {
            //     _res = await getGameUrlMainApi({
            //         id: item.id,
            //         ingress: 'pc' //移动端传h5 PC端传pc
            //     })
            //
            //     if (!_res.data) return
            //
            //     let _urls = _res.data.urls || []
            //     let params = _res.data.params
            //     let lastUrl = null
            //
            //     // 选择最快的
            //     try {
            //         let results = []
            //         _urls.forEach(url => {
            //             results.push(this.checkUrlSpeed(url +
            //                 `/ping.json?t=${Math.ceil(Math.random() * 1000000)}`))
            //         })
            //         Promise.any(results).then(res => {
            //             lastUrl = res.url.substring(0, res.url.indexOf('/ping')) + params
            // sessionStorage.setItem('webViewUrl',_res.data.gameUrl)
            //             this.setStoreState({prop: 'webViewUrl', value: lastUrl})
            //             callBack && callBack()
            //         }).catch(err => {
            //             this.$message({type: 'error', message: '网络连接错误！'})
            //         })
            //     } catch (error) {
            //         this.$message({type: 'error', message: '网络连接错误！'})
            //     }
            //     return
            // }
            //如果PLATid不为1的时候， 调用“获取第三方游戏登录链接接口”
            // if (item.platId !== 1) {
            _res = await getGameUrlApi({
                id: item.id,
                ingress: item.ingress.split('|')[0] //移动端传ingress[1] PC端传ingress[0]
            })

            if (!_res.data) return

            sessionStorage.setItem('webViewUrl', _res.data.gameUrl)
            sessionStorage.setItem('webViewConfig', JSON.stringify(item))
            this.setStoreState({prop: 'webViewConfig', value: item})
            this.setStoreState({prop: 'webViewUrl', value: _res.data.gameUrl})
            callBack && callBack()
            // return
            // }
        },
        disabledDateSelf(time, dayNum) { //日期选择 限制多少天以内 time-> 当前时间 dayNum -> 限制天数
            const today = new Date();
            const thirtyDaysLater = new Date();
            thirtyDaysLater.setDate(today.getDate() - dayNum);

            return time.getTime() >= today.getTime() || time.getTime() < thirtyDaysLater.getTime();
        },
        goldUnit(num) {
            if (!num && num !== 0) {
                return store.state.userInfo.currency === 'CNY' ? '￥' : '$'
            }

            const _negative = num < 0 ? '-' : ''

            return `${_negative}${store.state.userInfo.currency === 'CNY' ? '￥' : '$'}${parseFloat(Math.abs(num).toFixed(2))}`
        },
        getFormatDate(date) {
            // 提取年、月、日
            const year = date.getFullYear(); // 获取年份
            const month = date.getMonth() + 1; // 获取月份（从0开始，因此加1）
            const day = date.getDate(); // 获取日期

            // 格式化为 "年-月-日" 格式
            const formattedDate = `${year}-${month < 10 ? '0' + month : month}-${day < 10 ? '0' + day : day}`
            return formattedDate
        },
        getRandomNumber(min, max) {
            return Math.floor(Math.random() * max)
        },
        toOnlineService() { //跳转在线客服
            const _onlineService = store.state.platformInfo?.onlineService

            if (!_onlineService) {
                this.$message({type: 'warning', message: '暂无在线客服'})
                return
            }
            // console.log(_onlineService[this.getRandomNumber(0, _onlineService.length)])

            let _getRandomNumber = _onlineService[this.getRandomNumber(0, _onlineService.length)] + (store.state?.userInfo?.username || '')
            window.open(_getRandomNumber, '_blank')
        },
        exitFn() {   //退出登录
            localStorage.removeItem('token')
            localStorage.removeItem('refreshToken')
            localStorage.removeItem('userInfo')

            // location.reload()
            //回到首页
            location.href = '/'
        },
    }
}
